<template lang='pug'>
  i.svg-icon.svg-icon-confirm
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
       path(d='M42.216,74.287c-0.01,0-0.02,0-0.03,0c-1.47-0.008-2.875-0.604-3.903-1.655L16.067,49.905 c-2.123-2.172-2.083-5.654,0.088-7.778c2.172-2.123,5.655-2.083,7.778,0.088l18.326,18.747l33.851-33.885 c2.146-2.148,5.63-2.15,7.777-0.004c2.149,2.147,2.151,5.629,0.004,7.778L46.107,72.674C45.076,73.707,43.675,74.287,42.216,74.287z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>